<template>
  <div>
    <div class="hideTotal" v-if="operate === 'list'">
      <table-search label-width="90px" @search="fetchList(1)" @reset="handleReset">
        <template v-slot:basic>
          <el-form-item label="成交单号">
            <el-input v-model="query.id" placeholder="请输入成交单号"/>
          </el-form-item>
          <el-form-item label="报价方向">
            <el-select v-model="query.billType" placeholder="请选择报价方向">
              <el-option v-for="(item, index) in $key.transation.billType" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="成交总单状态">
            <el-select v-model="query.orderStatus" placeholder="请选择成交总单状态">
              <el-option v-for="(item, index) in $key.transation.orderStatus" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </template>
      </table-search>
      <inquery-result :isExport="false"></inquery-result>
      <el-table :data="tableData">
        <el-table-column label="成交总单" prop="id" align="center"/>
        <el-table-column label="商品名称" prop="productName" align="center"/>
        <el-table-column label="仓库" prop="whName" align="center"/>
        <el-table-column label="交货日期" prop="deliveryDay" align="center"/>
        <el-table-column label="报价方向" prop="billType" align="center">
          <template slot-scope="scope">
            {{ scope.row.billType | keyFilter('transation', 'billType') }}
          </template>
        </el-table-column>
        <el-table-column label="成交总额" prop="amount" align="center">
          <template slot-scope="scope">
            {{ scope.row.amount | thousandMark }}
          </template>
        </el-table-column>
        <el-table-column label="成交总数量" prop="qty" align="center"/>
        <el-table-column label="成交总单状态" prop="orderStatus" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus === 'OTHER_BREAK'">已完成</span>
            <span v-else>
              {{ scope.row.orderStatus | keyFilter('transation', 'orderStatus') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-action:detail type="text" @click="detail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" layout="total, prev, pager, next" :current-page.sync="currentNo" :total="total" background @current-change="fetchList"/>
    </div>
    <detail v-if="operate === 'detail'" :row="row" @close="close"/>
  </div>
</template>

<script>
import API from '@/api'
import detail from './detail'
function Query () {
  return {
    id: '', // 单号
    billType: null, // 方向
  }
}
export default {
  name: 'total',
  components: {
    detail
  },
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      tableData: [], // 表格数据
      operate: 'list',
      row: {},
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    fetchList (currentNo) {
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        pageNumber: this.currentNo,
        pageSize: 10
      }
      API.transationManage.totalList(param).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.totalElements
      })
    },
    detail (row) {
      this.row = row
      this.operate = 'detail'
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    close () {
      this.operate = 'list'
      this.fetchList(this.currentNo)
    }
  }
}
</script>
